

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface SocialHabitsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface SocialHabits { 
    id?: any;
    tenantId: any;
    branchId: any;  
    name:string;
    isActive?:Boolean;
    mappingAttribute?:string;
    snomedCode?:number;
    
    parameters?: SocialHabitsParameter[];
    links?: any;
}


export abstract class SocialHabitsData {
    
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<SocialHabits[]>;
    abstract create(url: string, data: SocialHabits): Observable<SocialHabits[]>;
    abstract update(url: string, data: SocialHabits): Observable<SocialHabits>;
    abstract delete(url: string): Observable<any>; 
}
